import actionTypes from "../actionTypes";
import config from "../../config";

const GUARD_NAME = "api";

export const getRoles = () => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.ROLES_FETCH,
  url: config.api.grantUrl + "/roles"
});

export const getRoleById = roleId => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.ROLE_FETCH,
  url: config.api.grantUrl + "/roles/" + roleId
});

export const postRole = (name, description) => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.ROLE_POST,
  url: config.api.grantUrl + "/roles",
  options: {
    method: "POST",
    body: JSON.stringify({
      name,
      description,
      guard_name: GUARD_NAME
    })
  }
});



// WEBPACK FOOTER //
// ./src/redux/actions/Roles.js